import { useQuery } from '@tanstack/react-query';
import { API_DINE_IN_URL } from '@/constants/config';
import { LONG_STALE_TIME } from '@/constants/queries';
import { queryKeys } from '@/constants/queryKeys';
import { fetch } from '@/utils/fetch';

export const useOutletKitchen = (outletId: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.outletKitchen({ outletId }),
    queryFn: ({ signal }) => fetch.get(`${API_DINE_IN_URL}/outlets/${outletId}`, { signal }),
    staleTime: LONG_STALE_TIME,
    enabled: !!outletId,
  });

  return {
    ...query,
    kitchenId: query.data?.data?.kitchenId,
    pointOfSaleId: query.data?.data?.pointOfSaleId,
    outletData: query.data?.data,
    country: query.data?.data?.country,
    currency: query.data?.data?.currency,
  };
};
